import { Box, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import eclipse from '../../assets/backoffice/eclipse.png';
import background from '../../assets/backoffice/background.png';
import TransactionTable from "../backoffice/TransactionTable";

function EfficientBackoffice() {
    return (
      <Box sx={{
            display: "flex",
            maxWidth: "1440px",
            width: "100%",
            margin: "0 auto",
            px: 1.5,
            flexDirection: "column",
            alignItems: "center",
            alignSelf: "stretch",
          }}>
        <Grid container spacing={1} width={"100%"}>
        <Grid size={{ xs: 12, md: 5 }} sx={{
          display: "flex",
          borderRadius: "12px",
          flexDirection: "column",
          alignItems: {md: "flex-start", xs: "flex-end"},
          gap: {md:"10px", xs: "64px"},
          alignSelf: "stretch",
          minHeight: {xs: "246px", md: "712px"},
          justifyContent: {md: "space-between", xs: "flex-start"},
          padding: {xs: "24px 20px", md: "48px"},
          flex: "1 0 0",
          backgroundColor: "darkPurple.500",
        }}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: {md: "32px", xs: "20px"},
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}>
            <Box 
                component="img" 
                src={eclipse} 
                alt="icon"
                sx={{
                  width: {md: "80px", xs: "60px"},
                  height: {md: "80px", xs: "60px"},
                }} 
              />
              <Typography variant="subtitle10" sx={{
                color: "beige.100"
              }}>
                Efficient<br/>backoffice  
              </Typography>
          </Box>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: {md: "32px", xs: "24px"},
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}>
              <Typography variant="body7" sx={{
                color: "beige.100",
                textTransform: "uppercase",
                maxWidth: "317px",
                alignSelf: "stretch",
              }}>
                Assign roles, automate processes, 
                and track progress with integrated 
                metrics powered by Apache Superset
              </Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }} sx={{ 
  borderRadius: "12px",
  backgroundColor: "beige.200",
  display: "flex",
  alignItems: "center", 
  justifyContent: "center",
  flexDirection: "column",
  padding: 0,
  height: "100%",
  minHeight: {xs: "246px", md: "712px"},
  overflow: "hidden"
}}>
  <Box sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center", 
    width: "100%",
    height: "100%",
    padding: { xs: 2, md: 3 }, 
    gap: 1 
  }}>
    <Typography variant="subtitle11" sx={{
      textTransform: "uppercase",
      color: "beige.800",
      textAlign: "center",
      margin: 0 
    }}>
      integrated metrics<br/>powered by Apache Superset
    </Typography>
    
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 1, md: 2 },
        flex: 1,
        backgroundImage: background ? `url(${background})` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >   
      <TransactionTable />
    </Box>
  </Box>
</Grid>
        </Grid>
      </Box>
    );
  }
  
  export default EfficientBackoffice;
  